import { BlameLogType } from '@debbie/common/dist/blamelog/index.js';
import { getVoucherLabel } from '@debbie/common/dist/economy/helpers/vouchers.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../theme.js';
import ButtonDrop from '../../ButtonDrop.js';
import CasePreview from '../../CasePreview/CasePreview.js';
import CasePreviewByCaseId from '../../CasePreview/CasePreviewByCaseId.js';
import { Badge, Money, PlaceholderLoader, Table } from '../../index.js';
import { Meta } from './style.js';
export const VoucherDetails = ({ blamelog }) => {
    const [showVoucherOpen, setShowVoucherOpen] = useState(false);
    return (React.createElement(ButtonDrop, { open: showVoucherOpen, onOpen: () => setShowVoucherOpen(true), onClose: () => setShowVoucherOpen(false), size: "mini", info: true, maxWidth: "500px", minWidth: "500px" },
        React.createElement(Meta, null,
            React.createElement(Table, { zebra: true },
                React.createElement(VoucherDetailsContent, { blamelog: blamelog })))));
};
const VoucherDetailsContent = ({ blamelog }) => {
    switch (blamelog.type) {
        case BlameLogType.CaseVoucherCreate:
            return React.createElement(CaseVoucherCreateContent, { blamelog: blamelog });
        case BlameLogType.CaseVoucherDelete:
            return React.createElement(CaseVoucherDeleteContent, { blamelog: blamelog });
        case BlameLogType.CaseVoucherPatch:
            return React.createElement(CaseVoucherPatchContent, { blamelog: blamelog });
        case BlameLogType.CaseVoucherExpired:
            return React.createElement(CaseVoucherExpiredContent, { blamelog: blamelog });
        case BlameLogType.CaseVoucherIrrecoverable:
            return React.createElement(CaseVoucherIrrecoverableContent, { blamelog: blamelog });
        case BlameLogType.UnknownCaseVoucherMapped:
            return React.createElement(UnknownCaseVoucherMappedContent, { blamelog: blamelog });
        case BlameLogType.CaseVoucherMoved:
            return React.createElement(CaseVoucherMovedContent, { blamelog: blamelog });
        case BlameLogType.FixedDistributionCreate:
            return React.createElement(FixedDistributionCreateContent, { blamelog: blamelog });
        case BlameLogType.FixedDistributionUpdate:
            return React.createElement(FixedDistributionUpdateContent, { blamelog: blamelog });
        case BlameLogType.FixedDistributionDelete:
            return React.createElement(FixedDistributionDeleteContent, { blamelog: blamelog });
        default:
            return null;
    }
};
// CaseVoucherCreate: caseVoucherId, voucherTypeId, amount, referenceId
const CaseVoucherCreateContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.caseVoucherInfoType)),
            React.createElement("td", null, lang.economyVoucherTypeLabels[details.voucherTypeId] || details.voucherTypeId)),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.amount)),
            React.createElement("td", null,
                React.createElement(Money, { amount: details.amount }))),
        details.referenceId && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.referenceId)),
            React.createElement("td", null, details.referenceId)))));
};
// CaseVoucherDelete: Full CaseVoucherSchema
const CaseVoucherDeleteContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.caseVoucherInfoType)),
            React.createElement("td", null, lang.economyVoucherTypeLabels[details.voucherTypeId] || details.label)),
        details.referenceId && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.referenceId)),
            React.createElement("td", null, details.referenceId))),
        details.caseId && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.cases.case)),
            React.createElement("td", null,
                React.createElement(CasePreviewByCaseId, { caseId: details.caseId })))),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.caseVoucherInfoCategory)),
            React.createElement("td", null, lang.economyCategories[details.category] ||
                details.category)),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.amount)),
            React.createElement("td", null,
                React.createElement(Money, { amount: details.amount, currency: details.currency }))),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.date)),
            React.createElement("td", null, moment(details.date).format(THEME.DATE_FORMAT_LONG))),
        details.text && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.voucherInfoText)),
            React.createElement("td", null, details.text)))));
};
// CaseVoucherPatch: PatchCaseVoucherSchema (partial fields)
const CaseVoucherPatchContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        details.amount != null && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.amount)),
            React.createElement("td", null,
                React.createElement(Money, { amount: details.amount })))),
        details.date && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.date)),
            React.createElement("td", null, moment(details.date).format(THEME.DATE_FORMAT_LONG)))),
        details.dueDate && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.dueDate)),
            React.createElement("td", null, moment(details.dueDate).format(THEME.DATE_FORMAT_LONG)))),
        details.interest != null && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.interestRate)),
            React.createElement("td", null,
                details.interest,
                "%"))),
        details.interestStartDate && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.interestStartDate)),
            React.createElement("td", null, moment(details.interestStartDate).format(THEME.DATE_FORMAT_LONG)))),
        details.interestEndDate && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.interestEndDate)),
            React.createElement("td", null, moment(details.interestEndDate).format(THEME.DATE_FORMAT_LONG)))),
        details.referenceId && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.referenceId)),
            React.createElement("td", null, details.referenceId))),
        details.text && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.voucherInfoText)),
            React.createElement("td", null, details.text))),
        details.state && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.caseVoucherInfoState)),
            React.createElement("td", null,
                React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, details.state)))),
        details.expired != null && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.caseVouchers.expired)),
            React.createElement("td", null, details.expired ? lang.misc.yes : lang.misc.no))),
        details.irrecoverableDate && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.caseVouchers.irrecoverableDate)),
            React.createElement("td", null, moment(details.irrecoverableDate).format(THEME.DATE_FORMAT_LONG)))),
        details.caseId && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.voucherInfoMoveToCase)),
            React.createElement("td", null,
                React.createElement(CasePreviewByCaseId, { caseId: details.caseId }))))));
};
// CaseVoucherExpired: Full CaseVoucherSchema
const CaseVoucherExpiredContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.caseVoucherInfoType)),
            React.createElement("td", null, lang.economyVoucherTypeLabels[details.voucherTypeId] || details.label)),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.amount)),
            React.createElement("td", null,
                React.createElement(Money, { amount: details.amount, currency: details.currency }))),
        details.expirationDate && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.expirationDate)),
            React.createElement("td", null, moment(details.expirationDate).format(THEME.DATE_FORMAT_LONG)))),
        details.referenceId && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.referenceId)),
            React.createElement("td", null, details.referenceId))),
        details.text && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.voucherInfoText)),
            React.createElement("td", null, details.text)))));
};
// CaseVoucherIrrecoverable: Full CaseVoucherSchema
const CaseVoucherIrrecoverableContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.caseVoucherInfoType)),
            React.createElement("td", null, lang.economyVoucherTypeLabels[details.voucherTypeId] || details.label)),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.amount)),
            React.createElement("td", null,
                React.createElement(Money, { amount: details.amount, currency: details.currency }))),
        details.irrecoverableDate && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.caseVouchers.irrecoverableDate)),
            React.createElement("td", null, moment(details.irrecoverableDate).format(THEME.DATE_FORMAT_LONG)))),
        details.referenceId && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.referenceId)),
            React.createElement("td", null, details.referenceId))),
        details.text && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.voucherInfoText)),
            React.createElement("td", null, details.text)))));
};
const UnknownCaseVoucherMappedContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const caseVouchersLoader = useCaseVouchersByCase(blamelog.refId);
    if (h.isLoading(caseVouchersLoader) || h.isNotLoaded(caseVouchersLoader)) {
        return (React.createElement("tr", null,
            React.createElement("td", { colSpan: 2 },
                React.createElement(PlaceholderLoader, null))));
    }
    if (h.isError(caseVouchersLoader)) {
        return null;
    }
    const caseVoucher = caseVouchersLoader.data.find((cv) => cv.caseVoucherId === blamelog.details);
    return (React.createElement(React.Fragment, null, caseVoucher?.referenceId && (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("b", null, lang.economy.referenceId)),
        React.createElement("td", null, caseVoucher.referenceId)))));
};
// CaseVoucherMoved: fromCaseId, toCaseId
const CaseVoucherMovedContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        details.fromCaseId && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.fromCase)),
            React.createElement("td", null,
                React.createElement(CasePreview, { caseId: details.fromCaseId, noTooltip: true })))),
        details.toCaseId && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.toCase)),
            React.createElement("td", null,
                React.createElement(CasePreview, { caseId: details.toCaseId, noTooltip: true }))))));
};
const FDVoucherRows = ({ caseId, fromCaseVoucherId, toCaseVoucherId, }) => {
    const lang = useSelector((s) => s.lang);
    const caseVouchersLoader = useCaseVouchersByCase(caseId);
    if (h.isLoading(caseVouchersLoader) || h.isNotLoaded(caseVouchersLoader)) {
        return (React.createElement("tr", null,
            React.createElement("td", { colSpan: 2 },
                React.createElement(PlaceholderLoader, null))));
    }
    if (h.isError(caseVouchersLoader)) {
        return null;
    }
    const fromVoucher = caseVouchersLoader.data.find((cv) => cv.caseVoucherId === fromCaseVoucherId);
    const toVoucher = caseVouchersLoader.data.find((cv) => cv.caseVoucherId === toCaseVoucherId);
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.fromVoucher)),
            React.createElement("td", null, fromVoucher ? getVoucherLabel(fromVoucher, lang) : '-')),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.toVoucher)),
            React.createElement("td", null, toVoucher ? getVoucherLabel(toVoucher, lang) : '-'))));
};
const FixedDistributionCreateContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement(FDVoucherRows, { caseId: blamelog.refId, fromCaseVoucherId: details.fromCaseVoucherId, toCaseVoucherId: details.toCaseVoucherId }),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.amount)),
            React.createElement("td", null,
                React.createElement(Money, { amount: details.amount })))));
};
const FixedDistributionUpdateContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement(FDVoucherRows, { caseId: blamelog.refId, fromCaseVoucherId: details.fromCaseVoucherId, toCaseVoucherId: details.toCaseVoucherId }),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.amount)),
            React.createElement("td", null,
                React.createElement(Money, { amount: details.previousAmount }),
                " \u2192",
                ' ',
                React.createElement(Money, { amount: details.amount })))));
};
const FixedDistributionDeleteContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement(FDVoucherRows, { caseId: blamelog.refId, fromCaseVoucherId: details.fromCaseVoucherId, toCaseVoucherId: details.toCaseVoucherId }),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.economy.amount)),
            React.createElement("td", null,
                React.createElement(Money, { amount: details.amount })))));
};
//# sourceMappingURL=VoucherDetails.js.map